import React, { useState, useRef } from 'react'
import { Card, Input, Modal, Spin } from 'antd';
import StringHelper from '../helpers/StringHelper';
import moment from 'moment-jalaali';
import { FileImageOutlined } from "@ant-design/icons";
import PictureUpload from '../file-upload/PictureUpload';
import axiosInstance from '../../axios';
import config from '../../config';
import { saveAs } from "file-saver";
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

const { TextArea } = Input;

export default function TicketDetailsFormModal() {
  const { business } = usePersistedStore();
  const general = useGeneralStore();
  const pictureUploader = useRef(null);
  const [message, setMessage] = useState("");
  const detailTicketModal = general.view.detailTicketModal
  const token = business.currentBusiness.token;
  const ticketDetails = general.ticketDetails.data;
  const loading = general.ticketDetails.loading;


  const handleAdminMessage = () => {

    const status = ticketDetails.Status;
    const attachFile = pictureUploader.current.state.fileList;


    var dataToSend = new FormData();
    dataToSend.append("contactUsId", ticketDetails.Id);
    dataToSend.append("message", message);
    if (attachFile.length > 0) {
      attachFile.map((file) => {
        dataToSend.append(file.name, file);
      })
    }

    general.postAdminMessage({ dataToSend, status });
    pictureUploader.current.setState({ fileList: [] });
    setMessage("");
  }
  const DownloaderAttachment = async (attch) => {
    try {
      const resp = await axiosInstance({
        method: "get",
        baseURL: config.apiUrls(),
        url: `v1/business/ticket-detail-attachment/${attch}`,
        headers: { token },
        responseType: 'blob',
      })

      const filename = Date.now().toString() + "." + resp?.data?.type?.split("/")[1];

      saveAs(resp.data, filename);
    } catch (error) {
      console.log('error', error)
    }
  };

  return (
    <Modal
      title={<Spin spinning={loading}>  مشاهده تیکت  {StringHelper.getFarsiNum(ticketDetails.Id)}  -  {ticketDetails.ContactUsTypeTitle}
        {StringHelper.getFarsiNum(ticketDetails.LastMessageDateTimeShamsi)}  -   {ticketDetails.StatusTitle} </Spin>}
      className="response-modal custom-table modal-scroll"
      footer={null}
      width={700}
      visible={detailTicketModal}
      onCancel={() => general.ToggleDetailsTicketFormModal(false)}>
      <Spin spinning={loading}>
        <div className="ticket-details">
          {ticketDetails && ticketDetails.Messages && ticketDetails.Messages.length > 0 && ticketDetails.Messages.map((ticket, index) => (
            <Card key={index} title={`${StringHelper.getFarsiNum(moment(((ticket.CreateDate))).format('HH:mm - jYYYY/jM/jD'))} - ${ticket.FullName && ticket.FullName} ${StringHelper.getFarsiNum(ticket.UserId)} || ${ticket.MessagePosterTypeTitle}`}
              className={ticket.MessagePosterType === 0 ? "header-userCard" : "header-AdminCard"} >
              {ticket.Message}
              {ticket.AttachmentsInfo.length > 0 && (
                <>
                  <ol style={{ textAlign: "left" }} >
                    {ticket.AttachmentsInfo.map((attch) => {
                      return (
                        <li
                          style={{ cursor: "pointer", display: "inline", marginLeft: "10px" }}
                          key={attch.Id}
                          onClick={() => DownloaderAttachment(attch.Id)}
                        >
                          <FileImageOutlined style={{ fontSize: "16px", color: "#40a9ff" }} />
                        </li>
                      );
                    })}
                  </ol>
                </>
              )}
            </Card>
          ))}
          {ticketDetails && ticketDetails.Status !== 2 && <div>
            <TextArea
              name="message"
              value={message}
              placeholder={ticketDetails.Status === 0 ? "شرح درخواست..." : ticketDetails.Status === 1 ? "پاسخ..." : ""}
              className="animated fadeIn"
              autoSize={{ minRows: 6, maxRows: 8 }}
              maxLength={3000}
              onChange={(e) => setMessage(e.target.value)}
            />
            <PictureUpload ref={pictureUploader} />
            <button type="primary" htmltype="submit" className="btn btn-success waves-effect waves-light"
              onClick={() => handleAdminMessage()}>
              <i className="bx bx-check-double font-size-16 align-middle mr-2"></i> ارسال
            </button>
          </div>}
        </div>
      </Spin>
    </Modal>
  )
}